<template>
  <div class="dash-card dashboard-header">
    <div class="dashboard-greeting">
      <div class="dashboard-greeting-avatar">
        <a-icon type="smile" theme="filled" />
      </div>
      <div>
        <h1 class="dashboard-greeting-text">
          {{ $t("accueil.dashboard.hello") }},
          <span class="dashboard-greeting-name">{{ displayName }}</span>
        </h1>
        <p class="dashboard-greeting-subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <div class="dashboard-header-actions">
      <div class="dashboard-date">
        <a-icon type="calendar" />
        {{ formattedDate }}
      </div>
      <a-button
        class="dashboard-refresh-btn"
        ghost
        :loading="loading"
        @click="$emit('refresh')"
      >
        <a-icon type="reload" />
        {{ $t("accueil.refresh") }}
      </a-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "GreetingWidget",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["user"]),
    displayName() {
      return this.user?.userName || this.$t("accueil.dashboard.guest");
    },
    formattedDate() {
      return moment().format("dddd D MMMM YYYY");
    },
    subtitle() {
      return this.$t("accueil.dashboard.subtitleOverview");
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 20px 24px;
  height: auto;
  background: var(--kit-color-primary, #4b7cf3);
  border-color: var(--kit-color-primary, #4b7cf3);

  &:hover {
    transform: none;
  }
}

.dashboard-greeting {
  display: flex;
  align-items: center;
  gap: 16px;
}

.dashboard-greeting-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
  border: none;
}

.dashboard-greeting-text {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
}

.dashboard-greeting-name {
  font-weight: 800;
  color: #fff;
}

.dashboard-greeting-subtitle {
  margin: 2px 0 0;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.85);
}

.dashboard-header-actions {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.dashboard-date {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #fff;
  background: rgba(255, 255, 255, 0.14);
  padding: 6px 12px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  text-transform: capitalize;
}

.dashboard-refresh-btn {
  border: none !important;
  box-shadow: none !important;

  &:hover,
  &:focus,
  &:active {
    border: none !important;
    box-shadow: none !important;
  }
}

@media (max-width: 576px) {
  .dashboard-header {
    flex-direction: column;
    align-items: stretch;
  }

  .dashboard-header-actions {
    justify-content: space-between;
  }
}
</style>
